import axios from "axios";
import { getOptions } from "../../helpers/api";

export const elements = {

  getOpenIncidentsTrend: (data) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Incident/GetOpenAndClosedIncidentsTrend`, data.body, headers);
  },

  getIncidentAging: (data) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Incident/GetIncidentAging`, data.body, headers);
  },

  getIncidentResolution: (data) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Incident/GetIncidentResolution`, data.body, headers);
  },

  getIncidentResolutionSummary: (data) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Incident/GetIncidentResolutionSummary`, data.body, headers);
  },

  getIncidentResolutionFilterLookups: (data) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/Incident/GetIncidentResolutionFilterLookups`, headers);
  },

  getIncidentResolutionProgress: (data) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Incident/GetIncidentResolutionProgress`, data.body, headers);
  },

  getSLAFilterLookUps: (data) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/SLA/GetLookups`, headers);
  },
  getSLADataSummary: (data) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/SLA/GetSLADataSummary`, data.body, headers);
  },



};
